import { UserSelectors } from '@core/account-data';
import type { GdprConfiguration, GdprSaveBody } from '@core/gdpr-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

const { actions, selectors, namespace, reducer } = createSingleEntityStore<GdprConfiguration>()(
  'GdprConfiguration',
  {
    references: makeRef => [makeRef('adminIds', 'admins', UserSelectors.byIds)],
    customActions: adapter => ({
      update: (state, payload: GdprSaveBody) => adapter.markAsPending(state),
      toggleGDPRFeature: (state, payload: GdprSaveBody) => adapter.markAsPending(state),
      toggleGDPRFeatureSuccess: (state, payload: GdprConfiguration) =>
        pipeState(adapter.update(state, payload), next => adapter.markAsLoaded(next)),
    }),
  },
);

export {
  actions as GdprConfigurationActions,
  selectors as GdprConfigurationSelectors,
  namespace as GdprConfigurationNamespace,
  reducer as GdprConfigurationReducer,
};
